import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';

export interface Props {
  text: string;
  height?: number;
  justify?: string;
  style?: any;
}

function NoItemsWrapper({
  style,
  text,
  height = 100,
  justify = 'center',
}: Props) {
  return (
    <Wrapper style={style} height={height} justify={justify}>
      {text}
    </Wrapper>
  );
}

const Wrapper = styled(FlexColCenter)<{ height: number; justify?: string }>`
  text-decoration: none;
  font-size: ${rem(18)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  width: 100%;
  padding: ${rem(16)};
  height: ${({ height }) => rem(height)};
  justify-content: ${({ justify }) => justify || 'flex-start'};
  margin: 0;
  display: block;
`;

export { NoItemsWrapper };
